var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"user-type"},_vm._l((_vm.$constants.USER_TYPE),function(user,i){return _c('li',{key:i,staticClass:"user-type__item",class:{ 'user-type__item--active': user === _vm.userType },on:{"click":function($event){return _vm.changeUserType(user)}}},[_vm._v(" "+_vm._s(_vm.$t(`user_type_${user}`))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }